import { axios } from "lib/axios"
import { toApiError } from './login';

export const requestAccess = async (data, message) => {
  try {
    await axios.post("/auth/request-access", {
      user: {
        first_name: data.firstName,
        last_name: data.lastName,
        phone_number: data.phoneNumber,
      },
      company: {
        vat: `SE${data.vat}01`,
      },
      message: message,
      'cf-turnstile-response': data.turnstileToken,
    });
  } catch (error) {
    throw toApiError(error);
  }
}
